import React from "react";
import BaseStepComponent from "./common/BaseStepComponent";

const Step3 = () => {
  return (
    <BaseStepComponent
      stepNumber={3}
      title="Call Script"
      videoSrc="https://contentmedius.s3.ap-south-1.amazonaws.com/part_3_-_call_script+(360p).mp4"
      directLink="https://contentmedius.s3.ap-south-1.amazonaws.com/part_3_-_call_script+(360p).mp4"
      nextStep={4}
    />
  );
};

export default Step3; 